import MessagingContacts from './MessagingContacts.component';

export default MessagingContacts;